import React, { useState, useEffect, useRef } from "react";
import Pagination from "../../shared/common/pagination";
import Loader from "../../shared/loader/loader";
import AddAndEditPracticeStandard from "./managePracticeStandards";
import DeleteModal from "../../shared/common/deleteModal";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { connect } from "react-redux";
import { useNavigate, Link } from "react-router";
import Constant from "../../../utils/constant";
import MultiSelectList from "../questions/metadataDropDownList";
import Tooltip from "../../shared/common/ellipsisText";
import {
  AddIcon,
  EditIcon,
  DeleteIcon,
  FilterIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  ApproveIcon,
  Disapprove,
  CSVIcon,
} from "../../../assets/icons/index";
import {
  getSkillStandardAll,
  deleteSkillStandardAPI,
  getSkillSubjects,
} from "../../../api/skill.service";
import ExportToCSV from "../../shared/common/exportToCsv";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";

const activeMultiState = [
  { label: "Active", value: true },
  { label: "Both", value: null, selected: true },
  { label: "Inactive", value: false },
];

const PracticeStandards: React.FC = (props: any) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [showAddEditModal, setShowAddEditModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [newSkills, setNewSkills] = useState<any>([]);
  const [editStandards, setEditStandards] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [newGradeDataToPass, setNewGradeDataToPass] = useState<any>([]);
  const [newContentDataToPass, setNewContentDataToPass] = useState<any>([]);
  const [newGrade, setNewGrade] = useState<any>([]);
  const [newContent, setNewContent] = useState<any>([]);
  const [deleteStandardSkill, setDeleteSkill] = useState<any>(null);
  const [newSkillSubject, setNewSkillSubject] = useState<any>([]);
  const [newSkillGrade, setNewSkillGrade] = useState<any>([]);
  const [selectgradeId, setselectgradeId] = useState(0);
  const [selectSkilSubjectid, setselectSkilSubjectid] = useState(0);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [newBackUpSubjects, setNewBackUpSubjects] = useState<any>([]);
  const [sortCol, setSortCol] = useState<string>("name");
  const [SortDir, setSortDir] = useState<any>(false);
  const [SkillStandardId, setSkillStandardId] = useState<string>("");
  const [isApproved, setisApproved] = useState<boolean>(true);
  const [subjects, setSubjects] = useState([]);
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const navigate = useNavigate();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const childRef: any = useRef(undefined);

  const filterHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const filteredSubject = [];
    const emptyFilter = false;
    getSkillStandardAll(
      SkillStandardId ? SkillStandardId : 0,
      selectSkilSubjectid,
      selectgradeId,
      isApproved,
      isActive,
      sortCol,
      SortDir ? "asc" : "desc",
      defaultPageSize,
      defaultPageNumber
    ).then((res) => {
      const data = res.data;
      setNewBackUpSubjects(data.data);
      setNewSkills(data.data);
      setTotalPages(Math.ceil(data.totalRecords / defaultPageSize));
      setTotalRecords(data.totalRecords);
      setLoading(false);
    });

    setNewSkills(filteredSubject);
  };

  const deleteStandardHandler = (e, id) => {
    e.preventDefault();
    setShowDeleteModal(true);
    const deleteGrade = newSkills.find((skill) => skill.skillStandardId === id);
    setDeleteSkill(deleteGrade);
  };

  const deleteRecordHandler = () => {
    const recordsAfterDelete: any[] = newSkills.filter(
      (subject: any) =>
        subject.skillStandardId !== deleteStandardSkill.skillStandardId
    );
    if (deleteStandardSkill.skillStandardId) {
      deleteSkillStandardAPI(deleteStandardSkill.skillStandardId);
      setTimeout(() => {
        setShowDeleteModal(false);
        standardDataReload();
      }, 1000);
    }
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const closeModal = () => {
    setShowAddEditModal(false);
  };

  const skillDataReload = () => {
    async function skillReload() {
      setLoading(true);
    }
    skillReload();
  };
  const getGradeData = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getGradeAll(100, pageNumber);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId,
          label: eachGradeData.name,
        };
      });
    }
    setNewGrade(newGradeData);
  };

  const standardDataReload = () => {
    async function standardReload() {
      setLoading(true);
      const response = getSkillStandardAll(
        0,
        selectSkilSubjectid,
        selectgradeId,
        isApproved === false ? isApproved : true,
        isActive,
        sortCol,
        SortDir ? "asc" : "desc",
        pageSize,
        pageNumber
      );
      const data = (await response).data;
      setNewSkills(data.data);
      setTotalPages(Math.ceil(data.totalRecords / pageSize));
      setTotalRecords(data.totalRecords);
      setLoading(false);
    }
    standardReload();
  };

  async function skillSUbject() {
    setLoading(true);
    const gradeSubjectsResponse = getSkillSubjects();
    const gradeSubjectsData = (await gradeSubjectsResponse).data;
    setNewContent(gradeSubjectsData.data);
    const subject = gradeSubjectsData.data.map((_g) => {
      return {
        label: _g.name,
        value: _g.skillSubjectId,
      };
    });
    setSubjects(subject);
    setLoading(false);
    getGradeData();
  }

  useEffect(() => {
    skillSUbject();
  }, []);

  useEffect(() => {
    if (isLoaded) {
      standardDataReload();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      standardDataReload();

      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const addSubject = (subject) => {
    setNewSkills([...newSkills, subject]);
  };

  const handleRedirect = (skills: any) => {
    const gradeDataToPass = newGrade.map((_g) => {
      return {
        label: _g.label,
        value: _g.value,
      };
    });
    const contentDataToPass = newContent.map((_g) => {
      return {
        label: _g.name,
        value: _g.skillSubjectId,
      };
    });
    setShowAddEditModal(true);
    setNewGradeDataToPass(gradeDataToPass);
    setNewContentDataToPass(contentDataToPass);
    const editSkill = newSkills.find(
      (skill) => skill.skillStandardId === skills.skillStandardId
    );

    let dropdownSelectedSubject = {};
    let dropdownSelectedGrade = {};
    const editSkills = newContent?.find(
      (item) => item.skillSubjectId === editSkill.skillSubjectId
    );
    const editGrades = newGrade?.find(
      (item) => item.value === editSkill.gradeId
    );
    dropdownSelectedSubject = {
      label: editSkills?.name,
      value: editSkills?.skillSubjectId,
    };
    dropdownSelectedGrade = {
      label: editGrades?.label,
      value: editGrades?.value,
    };
    setNewSkillSubject(dropdownSelectedSubject);
    setNewSkillGrade(dropdownSelectedGrade);
    setEditStandards(editSkill);
    navigate(
      Constant.MANAGESKILLSTANDARD.replace(
        ":id",
        skills.skillStandardId.toString()
      ),
      {
        state: {
          objectToEdit: skills,
          subjectData: contentDataToPass,
          gradeData: gradeDataToPass,
          selectSubjectData: dropdownSelectedSubject,
          selectGradeData: dropdownSelectedGrade,
        },
      }
    );
  };

  const handlePostRedirect = () => {
    const gradeDataToPass = newGrade.map((_g) => {
      return {
        label: _g.label,
        value: _g.value,
      };
    });
    const contentDataToPass = newContent.map((_g) => {
      return {
        label: _g.name,
        value: _g.skillSubjectId,
      };
    });
    navigate(Constant.ADDSKILLSTANDARD, {
      state: {
        objectToEdit: null,
        subjectData: contentDataToPass,
        gradeData: gradeDataToPass,
      },
    });
  };

  const handleSortBy = (column: string) => {
    setSortDir(!SortDir);
    setSortCol(column);
  };

  const bindSubjects = () => {
    setLoading(true);
    getSkillStandardAll(
      0,
      selectSkilSubjectid,
      selectgradeId,
      isApproved,
      isActive,
      sortCol,
      SortDir ? "asc" : "desc",
      pageSize,
      pageNumber
    ).then((response) => {
      setNewSkills(response.data.data);
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (isLoaded) bindSubjects();
  }, [SortDir]);

  const resetClickHandler = () => {
    setLoading(true);

    setNewSkills(newBackUpSubjects);
    setselectSkilSubjectid(0);
    setisApproved(true);
    setIsActive(undefined);
    setSkillStandardId("");
    setselectgradeId(0);
    setResetDropdownFlag(!resetDropdownFlag);
    getSkillStandardAll(
      0,
      selectSkilSubjectid,
      selectgradeId,
      true,
      true,
      sortCol,
      SortDir ? "asc" : "desc",

      pageSize,
      pageNumber
    ).then((response) => {
      setNewSkills(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  const exportFn = async () => {
    setLoading(true);
    const response = getSkillStandardAll(
      SkillStandardId ? SkillStandardId : 0,
      selectSkilSubjectid ? selectSkilSubjectid : 0,
      selectgradeId ? selectgradeId : 0,
      isApproved,
      isActive,
      sortCol,
      SortDir ? "asc" : "desc",
      9999,
      1
    );

    const data = (await response).data;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "practiceStandards.csv");
    } else {
      const module = await import("react-toastify");
      module.toast.warning("No records to download");
    }
  };

  return (
    <AllowedTo
      perform={Permissions.skill_practice_standard_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showAddEditModal && (
        <AddAndEditPracticeStandard
          closeModal={closeModal}
          showAddEditModal={showAddEditModal}
          skillDataReload={skillDataReload}
          gradesData={newGradeDataToPass}
          contentData={newContentDataToPass}
          addSubject={addSubject}
          standardDataReload={standardDataReload}
          editStandards={editStandards}
          newContent={newContent}
          newGrade={newGrade}
          newSkillSubject={newSkillSubject}
          newSkillGrade={newSkillGrade}
          userID={props.profile?.userId}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14  mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div id="dataContainer" className="mt-4">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-light text-gray-900">
                  Skill Practice Standard
                </h3>
                <AllowedTo perform={Permissions.skill_practice_standard_create}>
                  <button
                    type="button"
                    className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                    onClick={() => handlePostRedirect()}
                  >
                    <AddIcon className="w-6"></AddIcon>
                    Add Skill Practice Standard
                  </button>
                </AllowedTo>
              </div>
              <form action="#" onSubmit={filterHandler}>
                <div className="pt-6 border-b pb-6">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">
                        Skill Standard Id
                      </label>
                      <div className="contentArea mt-1">
                        <input
                          id="name"
                          name="name"
                          type="text"
                          placeholder=""
                          className="w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"
                          value={SkillStandardId}
                          onChange={(event: any) =>
                            setSkillStandardId(event.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">Grade</label>
                      <div className="contentArea mt-1 text-sm">
                        <MultiSelectList
                          dropValue={newGrade}
                          defaultValue={""}
                          value={selectgradeId}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setselectgradeId}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 ">
                      <label className="text-sm text-gray-700">Subject</label>
                      <div className="contentArea mt-1 text-sm">
                        <MultiSelectList
                          dropValue={subjects}
                          defaultValue={""}
                          value={selectSkilSubjectid}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setselectSkilSubjectid}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 flex items-center mt-6">
                      <MultiStateButton
                        labels={activeMultiState}
                        onSelect={(e) => setIsActive(e.value)}
                        onReset={resetDropdownFlag}
                      />
                    </div>
                    <div className="col-span-1 flex items-end">
                      <div className="flex items-center ">
                        <input
                          id="isApproved"
                          name="isApproved"
                          type="checkbox"
                          checked={isApproved}
                          onChange={(e: any) => {
                            setisApproved(!isApproved);
                          }}
                          className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                        />
                        <label className="text-sm text-gray-700 ml-2">
                          Approved
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-start">
                    <button
                      type="submit"
                      className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    >
                      <FilterIcon className="w-3 h-3"></FilterIcon>
                      <span>Filter</span>
                    </button>
                    <button
                      type="button"
                      onClick={resetClickHandler}
                      className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                    >
                      <ResetIcon className="w-3 h-3"></ResetIcon>
                      <span>Reset Filter</span>
                    </button>
                  </div>
                </div>
                <div className="flex justify-end mb-2">
                  <button
                    type="button"
                    onClick={() => exportFn()}
                    className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                    <span>Export</span>
                  </button>
                  <ExportToCSV ref={childRef} />
                </div>
              </form>
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Id
                                <span className="cursor-pointer">
                                  {SortDir && sortCol === "skillStandardId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("skillStandardId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("skillStandardId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Name
                                <span className="cursor-pointer">
                                  {SortDir && sortCol === "Name" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("Name")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("Name")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Code
                                <span className="cursor-pointer">
                                  {SortDir && sortCol === "Code" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("Code")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("Code")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              Subject
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              Grade
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              Description
                            </th>

                            <th
                              scope="col"
                              className="w-10 px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {newSkills.map((skills, index) => (
                            <tr
                              key={skills.skillStandardId}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-100"
                              }
                            >
                              <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500 relative">
                                {skills.isActive ? (
                                  <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                ) : (
                                  <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                )}
                                <Link
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  to={Constant.MANAGESKILLSTANDARD.replace(
                                    ":id",
                                    skills.skillStandardId.toString()
                                  )}
                                >
                                  {skills.skillStandardId}
                                </Link>
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  to={Constant.MANAGESKILLSTANDARD.replace(
                                    ":id",
                                    skills.skillStandardId.toString()
                                  )}
                                >
                                  {skills.name}
                                </Link>
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                {skills.code}
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  to={Constant.MANAGESKILLSUBJECT.replace(
                                    ":id",
                                    skills.skillSubjectId
                                      ? skills.skillSubjectId.toString()
                                      : ""
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {skills.skillSubjectName}
                                </Link>
                              </td>
                              <td className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline">
                                <Link
                                  to={Constant.EDITGRADE.replace(
                                    ":id",
                                    skills.gradeId
                                      ? skills.gradeId.toString()
                                      : ""
                                  )}
                                >
                                  {skills.gradeName}
                                </Link>
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-500">
                                <Tooltip text={skills?.description} />
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                <div className="flex gap-3 justify-center">
                                  {skills.isApproved ? (
                                    <ApproveIcon />
                                  ) : (
                                    <Disapprove />
                                  )}
                                  <AllowedTo
                                    perform={
                                      Permissions.skill_practice_standard_modify
                                    }
                                  >
                                    <EditIcon
                                      onClick={(e) => handleRedirect(skills)}
                                      className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                    />
                                  </AllowedTo>
                                  <AllowedTo
                                    perform={
                                      Permissions.skill_practice_standard_delete
                                    }
                                  >
                                    <DeleteIcon
                                      onClick={(e) =>
                                        deleteStandardHandler(
                                          e,
                                          skills.skillStandardId
                                        )
                                      }
                                      className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                    />
                                  </AllowedTo>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  {newSkills.length !== 0 ? (
                    <>
                      <Pagination
                        pages={totalPages}
                        setPageNumber={setPageNumber}
                        ref={paginationRef}
                      />
                      <span>
                        <span className="text-sm pr-4 ml-auto text-left-700">
                          Showing {pageNumber} to{" "}
                          {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                          {totalRecords} results
                        </span>

                        <SelectPageSize
                          setPageSize={setPageSize}
                          type={"second"}
                          ref={pageSizeRef}
                        />
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(PracticeStandards);
